import * as R from 'ramda';
import { createSelector } from 'reselect';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
} = getReportSelectors('reports');

const makeSelectFilterProps = () => createSelector(
  (state) => state.reports,
  ({ filterProps }) => filterProps,
);

const makeSelectIsEditPage = () => createSelector(
  (state) => state.reports,
  ({ isEditPage }) => isEditPage,
);

const makeSelectSelectedList = () => createSelector(
  R.pathOr({}, ['reports', 'itemList']),
  R.compose(
    R.keys,
    R.filter(({ selected }) => selected),
  ),
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectIsEditPage,
  makeSelectFilterProps,
  makeSelectSelectedList,
  makeSelectTitleSortValues,
  makeSelectTableTitleFilters,
};
